import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Container from "@mui/material/Container";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewWizardContainer({
    title = "Default Title", // Title of the AppBar
    buttonTitle = "Add", // Title for the Fab button
    childComponent: ChildComponent, // Child component passed as a prop
    onClose: onDialogClose = () => { }, // Optional callback for dialog close
}) {
    const [dialogOpen, setDialogOpen] = React.useState(false);

    const handleDialogClose = () => {
        setDialogOpen(false);
        onDialogClose();
    };

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    return (
        <>
            <Box sx={{ "& > :not(style)": { m: 1 } }}>
                <Fab
                    onClick={handleDialogOpen}
                    title={buttonTitle}
                    className="floatRight"
                    color="primary"
                    aria-label="add"
                >
                    <AddIcon />
                </Fab>
            </Box>
            <Dialog
                fullScreen
                open={dialogOpen}
                onClose={handleDialogClose}
                TransitionComponent={Transition}
                disableEnforceFocus
            >
                <AppBar  sx={{ position: "relative" }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleDialogClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {title} {/* Title passed as a prop */}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <Container maxWidth="lg">
                        {ChildComponent && <ChildComponent handleDialogClose={handleDialogClose} />}
                    </Container>
                </DialogContent>
            </Dialog>
        </>
    );
}
